<a  class="drop-item" *ngIf="themeService.getThemes() == 'light'" (click)="setTheme('dark')">
    <!-- <app-icon [iconName]="'sun'" [width]="30" [height]="30"></app-icon>  -->
    <i class="fi fi-rr-brightness"></i>
    <span *ngIf="isName">light</span>
</a>

<a class="drop-item" *ngIf="themeService.getThemes() == 'dark'"  (click)="setTheme('system')"> 
    <!-- <app-icon [iconName]="'moon'" [width]="30" [height]="30"></app-icon>  -->
    <i class="fi fi-rr-moon"></i>
    <span *ngIf="isName">dark</span>
</a>

<a class="drop-item" *ngIf="themeService.getThemes() == 'system'" (click)="setTheme('light')"> 
    <!-- <app-icon [iconName]="'system'" [width]="30" [height]="30"></app-icon>  -->
    <i class="fi fi-rr-insight-alt"></i>
    <span *ngIf="isName" >system</span>
</a>




